module.exports = __webpack_public_path__ + "static/media/exemplo-img-primeira-receita-desk.328f8f6f.png";